const RELOAD_FLAG = 'chunk-reload';

// Vite fires this event when a dynamic import fails (e.g. stale chunk after deploy)
window.addEventListener('vite:preloadError', (event) => {
  if (!sessionStorage.getItem(RELOAD_FLAG)) {
    sessionStorage.setItem(RELOAD_FLAG, '1');
    window.location.reload();
    event.preventDefault();
  }
});

// Clear the flag on successful page load so future deploys can trigger a reload
sessionStorage.removeItem(RELOAD_FLAG);
